module.exports = "images/directs.a23c49a3.png";